import styled from 'styled-components';
import { StyleButtonBase } from '../button-base';
import { getSizeBy, getThemeProp, getColorShade, getColor } from '../../../src/styled/utils';
export const StyledAppBarButton = styled.button `
  ${StyleButtonBase}
  padding: ${getSizeBy(2)};
  color: ${getColor('onSurface')};
  background-color: transparent;
  border-radius: ${getThemeProp('borderRadius')}px;

  &:disabled {
    color: ${getColorShade('onSurface', 'outline')};
  }

  &:not(:disabled) {
    color: ${({ $selected }) => $selected && getColor('primary')};
    background-color: ${({ $selected }) => $selected && getColorShade('primary', 'selected')};
    cursor: pointer;
  }

  &:not(:disabled):hover,
  &:not(:disabled):focus,
  &:not(:disabled):active {
    color: ${getColor('primary')};
  }

  &:not(:disabled):hover {
    background-color: ${getColorShade('primary', 'hover')};
  }

  &:not(:disabled):focus {
    background-color: ${getColorShade('primary', 'focused')};
  }

  &:not(:disabled):active {
    background-color: ${getColorShade('primary', 'pressed')};
  }

  & svg path {
    fill: currentcolor;
  }
`;
